function MemberPrePaidBookingService($q, BBModel) {
    'ngInject';

    return {
        query(member, params) {
            const deferred = $q.defer();
            if (!params) {
                params = {};
            }
            params.no_cache = true;
            if (!member.$has('pre_paid_bookings')) {
                deferred.reject('member does not have pre paid bookings');
            } else {
                member.$get('pre_paid_bookings', params).then((bookings) => {
                        let booking;
                        if (angular.isArray(bookings)) {
                            // pre paid bookings embedded in member
                            bookings = (() => {
                                const result = [];
                                for (booking of Array.from(bookings)) {
                                    result.push(new BBModel.PrePaidBooking(booking));
                                }
                                return result;
                            })();
                            return deferred.resolve(bookings);
                        } else {
                            params.no_cache = false;
                            return bookings.$get('pre_paid_bookings', params).then((bookings) => {
                                    bookings = (() => {
                                        const result1 = [];
                                        for (booking of Array.from(bookings)) {
                                            result1.push(new BBModel.PrePaidBooking(booking));
                                        }
                                        return result1;
                                    })();
                                    return deferred.resolve(bookings);
                                }
                            );
                        }
                    }
                    , (err) => {
                        return deferred.reject(err);
                    }
                );
            }
            return deferred.promise;
        }
    };
}

angular
    .module('BBMember')
    .factory('MemberPrePaidBookingService', MemberPrePaidBookingService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_services/member_pre_paid_bookings.service.js